export const decodeObjectValues = (obj: { [key: string]: string }): { [key: string]: string }  => {
    const decodedObj: { [key: string]: string } = {};
    for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
            const decodedValue = decodeURIComponent(obj[key]);
            decodedObj[key] = decodedValue;
        }
    }
    return decodedObj;
}
